import { useState } from "react";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    const formData = new URLSearchParams();
    formData.append("email", email);
    try {
      await fetch("https://readdy.ai/api/form/d7dcn445q56ra7tufjh0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer className="bg-[#1a0a0a] text-white">
      {/* Top Footer */}
      <div className="max-w-[1400px] mx-auto px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/3fc89005e5f8f541d0781d07714068dd/b31ed3570265bb91107b593ba40da4ad.jpeg"
                alt="Crown Prime Mall Logo"
                className="h-10 w-10 rounded-full object-cover"
              />
              <div>
                <div className="font-bold text-base text-[#D4AF37]">Crown Prime Mall</div>
                <div className="text-[10px] text-gray-400">USA &amp; Canada Marketplace</div>
              </div>
            </div>
            <p className="text-gray-400 text-xs leading-relaxed mb-4">
              Connecting factory suppliers with buyers, influencers, and resellers across the USA and Canada. Secure USD payments. Fast local delivery.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-facebook-circle-fill", href: "#", color: "hover:text-[#1877F2]" },
                { icon: "ri-twitter-x-line", href: "#", color: "hover:text-white" },
                { icon: "ri-tiktok-line", href: "#", color: "hover:text-white" },
                { icon: "ri-youtube-line", href: "#", color: "hover:text-[#FF0000]" },
                { icon: "ri-whatsapp-line", href: "https://wa.me/1234567890", color: "hover:text-[#25D366]" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-8 h-8 flex items-center justify-center border border-white/20 rounded-full text-gray-400 ${s.color} transition-colors cursor-pointer`}
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-[#D4AF37] mb-4 text-sm">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { label: "Factory Suppliers", href: "#suppliers" },
                { label: "USA Wholesale Bulk Orders", href: "/wholesale" },
                { label: "Canada Wholesale Bulk Orders", href: "/canada-wholesale" },
                { label: "Influencer Hub", href: "#influencers" },
                { label: "Education Books", href: "#education" },
                { label: "USA Warehouse", href: "#usa-warehouse" },
                { label: "Canada Warehouse", href: "#canada-warehouse" },
                { label: "Become a Supplier", href: "#contact" },
                { label: "Reseller Program", href: "#influencers" },
              ].map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-gray-400 text-xs hover:text-[#D4AF37] transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-bold text-[#D4AF37] mb-4 text-sm">Support</h4>
            <ul className="space-y-2">
              {[
                "Help Center",
                "Shipping Information",
                "Returns & Refunds",
                "Track Your Order",
                "Contact Us",
                "Privacy Policy",
                "Terms of Service",
              ].map((item) => (
                <li key={item}>
                  <a href="#" className="text-gray-400 text-xs hover:text-[#D4AF37] transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-bold text-[#D4AF37] mb-4 text-sm">Stay Updated</h4>
            <p className="text-gray-400 text-xs mb-4 leading-relaxed">
              Get the latest deals, new suppliers, and dropshipping tips delivered to your inbox.
            </p>
            {submitted ? (
              <div className="bg-green-500/20 border border-green-500/30 text-green-400 text-xs px-4 py-3 rounded-lg">
                <i className="ri-check-line mr-2"></i>Thanks! You&apos;re subscribed.
              </div>
            ) : (
              <form
                data-readdy-form
                id="newsletter-form"
                onSubmit={handleNewsletterSubmit}
                className="flex flex-col gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="bg-white/10 border border-white/20 text-white placeholder-gray-500 text-xs px-4 py-3 rounded-lg outline-none focus:border-[#D4AF37] transition-colors"
                />
                <button
                  type="submit"
                  className="bg-[#C41E3A] text-white text-xs font-bold py-3 rounded-lg hover:bg-[#a01830] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Subscribe Now
                </button>
              </form>
            )}

            {/* Payment Icons */}
            <div className="mt-6">
              <div className="text-gray-500 text-[10px] mb-2 uppercase tracking-wider">Secure Payments</div>
              <div className="flex flex-wrap gap-2">
                {["VISA", "MC", "PayPal", "Amex", "USD"].map((p) => (
                  <span key={p} className="bg-white/10 text-gray-300 text-[10px] px-2 py-1 rounded font-bold border border-white/10">
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <div className="text-gray-500 text-xs">
            &copy; 2026 Crown Prime Mall. All rights reserved. USA &amp; Canada Marketplace.
          </div>
          <div className="flex gap-4">
            {["Terms", "Privacy", "Cookies", "Sitemap"].map((item) => (
              <a key={item} href="#" className="text-gray-500 text-xs hover:text-[#D4AF37] transition-colors cursor-pointer">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
